/**
 * POST /v1/incidents — request and response shapes.
 *
 * Either starts an incident immediately (omit `scheduledAt`) or
 * schedules one for later (`scheduledAt` ISO timestamp).
 */

import { z } from 'zod'

import { IncidentTypeSchema } from '../../schemas/entities/incident'

export { IncidentResponseSchema, type IncidentResponse } from './common'

export const CreateIncidentRequestSchema = z.object({
  type: IncidentTypeSchema.optional(),
  scheduledAt: z.string().datetime().optional(),
  metadata: z.record(z.string(), z.unknown()).optional()
})
export type CreateIncidentRequest = z.infer<typeof CreateIncidentRequestSchema>
